import { useEffect, useState } from 'react';
import { useEstadoPago } from '../utils/const/estado-pago-const';
import { useTranslation } from "react-i18next";
import { ESTILO_BOTON_LISTAR_ATRAS } from '../utils/const/estilos-const';
import Select from "react-select";
import { createRegistroPago } from '../api/api-registro-pago';

const ModalRegistrarPago = ({ isOpen, obj, onClose }) => {

    const ESTADO_PAGO = useEstadoPago();
    const { t } = useTranslation();
    const [estadoPagoSelected, setEstadoPagoSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        monto: "",
    });

    const charLimits = {
        monto: 10,
    };

    useEffect(() => {
        setIsLoading(false);
        setFormData({
            monto: "",
        });
        setEstadoPagoSelected(null);
    }, [isOpen, obj]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validar = () => {
        let result = { error: true, message: "" };
        let message = "";
        if (formData.monto.trim().length === 0) {
            message = message + t("alert_must_enter_amount") + "\n";
        }
        if (estadoPagoSelected === null) {
            message = message + t("alert_must_select_estado_pago") + "\n";
        }
        result.message = message;
        if (message.length === 0) {
            result.error = false;
        }
        return result;
    };

    const btnClickOnAceptar = async () => {
        try {
            setIsLoading(true);
            const valido = validar();
            if (valido.error === true) {
                alert(valido.message);
                setIsLoading(false);
                return;
            }
            let objEnviar = {};
            objEnviar.idEmpresaPlataforma = obj.id;
            objEnviar.idMoneda = obj.idMoneda;
            objEnviar.totalCobro = formData.monto;
            objEnviar.idEstadoPago = estadoPagoSelected.value;
            const response = await createRegistroPago(objEnviar);
            if (response.error === true) {
                alert(t("alert_no_se_pudo_processar"));
            }
            if (response.error === false) {
                alert(t("alert_procesado_correctamente"));
                onClose();
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-lg  overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">{t("label_registrar_pago")}</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className='flex justify-between'>
                    <label><strong>{t("label_company")}</strong>:{obj?.nombre}</label>
                    <label><strong>{t("label_total")}</strong>:{obj?.totalCobro}</label>
                    <label><strong>{t("label_moneda")}</strong>:{obj?.moneda}</label>
                </div>

                <div>
                    <div className="mt-4">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="monto">
                            {t("label_monto")}<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            id="monto"
                            name="monto"
                            value={formData.monto}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                            placeholder={t("label_monto")}
                            maxLength={charLimits.monto}
                        />
                        <p className="text-sm text-gray-500 flex justify-end">{formData.monto.length}/{charLimits.monto}</p>
                    </div>
                    <div className="mt-4">
                        <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="estado">
                            {t("label_estado")}<span className="text-red-500">*</span>
                        </label>
                        <Select
                            options={ESTADO_PAGO}
                            isSearchable={true}
                            isClearable={true}
                            value={estadoPagoSelected}
                            onChange={(event) => { setEstadoPagoSelected(event); }}
                            placeholder={t("label_select_estado")}
                            className="w-full"
                            menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                        />
                        <p className="text-sm text-gray-500 flex justify-end">&nbsp;</p>
                    </div>
                </div>

                <div className="flex justify-between pb-4 pr-4">
                    <button
                        className={ESTILO_BOTON_LISTAR_ATRAS}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    {isLoading === false &&
                        <button
                            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 cursor-pointer"
                            onClick={btnClickOnAceptar}
                        >
                            Aceptar
                        </button>
                    }
                    {isLoading === true &&
                        <button
                            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 cursor-pointer"
                        >
                            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </button>
                    }
                </div>
            </div >
        </div >
    );
};

export default ModalRegistrarPago;